export const getDefaultState = () => {
  return {
    statusHistory: []
  };
};

export default {
  ...getDefaultState()
};
